import { MatBadgeModule } from '@angular/material/badge';
import { MatGridListModule } from '@angular/material/grid-list';
import { OrderMessageComponent } from './pages/page-order-details/component/order-details/componenet/message-information/order-messages.component';
import { PageQuotationRequestDetailsComponent } from './pages/page-quotation-request-details/page-quotation-request-details.component';
import { PageGenericQuotationListComponent } from './pages/page-generic-quotation-list/page-generic-quotation-list.component';
import { PayProfessionalDialogComponent } from './pages/page-order-details/component/professional-order-details/componenet/pay-professional-dialog/pay-professional-dialog.component';
import { MatTabsModule as MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule as MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { NgModule } from '@angular/core';

// modules (angular)
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

// modules
import { AccountRoutingModule } from './account-routing.module';
import { SharedModule } from '@shared/shared.module';

// components
import { LayoutComponent } from './components/layout/layout.component';

// pages
import { PageAddressesListComponent } from './pages/page-addresses-list/page-addresses-list.component';
import { PageDashboardComponent } from './pages/page-dashboard/page-dashboard.component';
import { PageLoginComponent } from './pages/page-login/page-login.component';
import { PageOrdersListComponent } from './pages/page-orders-list/page-orders-list.component';
import { PagePasswordComponent } from './pages/page-password/page-password.component';
import { PageProfileComponent } from './pages/page-profile/page-profile.component';
import { PageEditAddressComponent } from './pages/page-edit-address/page-edit-address.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PageMessagesComponent } from './pages/page-messages/page-messages.component';
import { MessageInformationComponent } from './pages/page-messages/components/message-information/message-information.component';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PageQuotationsListComponent } from './pages/page-quotations-list/page-quotations-list.component';
import { QuotationModule } from '../page-quotation-cart/quotation-cart.module';
import { QuotationDetailsModule } from '../page-quotation/quotation.module';
import { PageActiveQuotationsListComponent } from './pages/page-active-quotations-list/page-active-quotations-list.component';
import { PageRequestQuotationsListComponent } from './pages/page-request-quotations-list/page-request-quotations-list.component';
import { PageQuotationDetailsComponent } from './pages/page-quotation-details/page-quotation-details.component';
import { PageLoyaltyComponent } from './pages/page-loyalty/unused-page-loyalty.component';
import { PageVouchersComponent } from './pages/page-vouchers/page-vouchers.component';
import { MatSlideToggleModule as MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { PageLiveChatComponent } from './pages/page-live-chat/page-live-chat.component';
import { PageOrderDetailsParentComponent } from './pages/page-order-details/page-order-details.component';
import { CancelOrderInformationComponent } from './pages/page-order-details/component/order-details/componenet/cancel-order-information/cancel-order-information.component';
import { CancelProfessionalDialogComponent } from './pages/page-order-details/component/professional-order-details/componenet/cancel-order-dialog/cancel-order-dialog.component';
import { CancelProfessionalOrderInformationComponent } from './pages/page-order-details/component/professional-order-details/componenet/cancel-order-information/cancel-order-information.component';
import { professionalOrderDetailsComponent } from './pages/page-order-details/component/professional-order-details/professional-order-details.component';
import { CancelReasonsDialogComponent } from './pages/page-order-details/component/order-details/componenet/cancel-order-dialog/cancel-order-dialog.component';
import { ReturnOrderInformationComponent } from './pages/page-order-details/component/order-details/componenet/return-order-information/return-order-information.component';
import { ReturnReasonsDialogComponent } from './pages/page-order-details/component/order-details/componenet/return-order-dialog/return-order-dialog.component';
import { PageVendorOrderDetailsComponent } from './pages/page-order-details/component/order-details/order-details.component';
import { PagePropertyListComponent } from './pages/page-property/property-list/page-property-list.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PropertyDetailsComponent } from './pages/page-property/property-details/property-details.component';
import { PageBookingsComponent } from './pages/page-bookings/page-bookings.component';

@NgModule({
    imports: [
        // modules (angular)
        CommonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        FlexLayoutModule,
        // modules
        AccountRoutingModule,
        SharedModule,
        QuotationModule,
        QuotationDetailsModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatDividerModule,
        MatDialogModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatCheckboxModule,
        MatTableModule,
        MatExpansionModule,
        MatTabsModule,
        MatGridListModule,
        MatBadgeModule,
        MatDividerModule,
        MatPaginatorModule,
        // components
        LayoutComponent,
        // pages
        PageAddressesListComponent,
        PageDashboardComponent,
        PageOrdersListComponent,
        PagePasswordComponent,
        PageProfileComponent,
        PageEditAddressComponent,
        PageMessagesComponent,
        MessageInformationComponent,
        PageQuotationsListComponent,
        PageActiveQuotationsListComponent,
        PageRequestQuotationsListComponent,
        PageQuotationDetailsComponent,
        PageLoyaltyComponent,
        PageVouchersComponent,
        PageLiveChatComponent,
        professionalOrderDetailsComponent,
        CancelProfessionalOrderInformationComponent,
        CancelProfessionalDialogComponent,
        CancelOrderInformationComponent,
        CancelReasonsDialogComponent,
        CancelOrderInformationComponent,
        ReturnOrderInformationComponent,
        ReturnReasonsDialogComponent,
        ReturnOrderInformationComponent,
        PageOrderDetailsParentComponent,
        PageVendorOrderDetailsComponent,
        PayProfessionalDialogComponent,
        PageGenericQuotationListComponent,
        PageQuotationRequestDetailsComponent,
        OrderMessageComponent,
        PagePropertyListComponent,
        PropertyDetailsComponent,
        PageBookingsComponent
    ],
    exports: [
        PageLiveChatComponent,
        PageVendorOrderDetailsComponent,
        professionalOrderDetailsComponent,
    ]
})
export class AccountModule { }
